import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { Sidebar } from '../components/Sidebar';
interface DashboardLayoutProps {
  children: React.ReactNode;
}
export const DashboardLayout = ({
  children
}: DashboardLayoutProps) => {
  return <Flex w="100%" minH="100vh" bg="gray.900">
      <Sidebar />
      <Box ml="250px" p={8} w="full">
        {children}
      </Box>
    </Flex>;
};